<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小窝装扮</el-breadcrumb-item>
      <el-breadcrumb-item>小窝装扮</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">

        <el-col :span="5">
          <el-input
            v-model="queryInfo.id"
            placeholder="请输入小窝ID"
            clearable
          ></el-input>
        </el-col>

        <el-col :span="5">
          <el-input
            v-model="queryInfo.sceneName"
            placeholder="请输入小窝名称"
            clearable
          ></el-input>
          <!--          <el-input-->
          <!--            v-model="queryInfo.channels"-->
          <!--            type="channels"-->
          <!--            placeholder="选择渠道"-->
          <!--          ></el-input>-->
        </el-col>

        <el-col :span="5">
          <el-select
            v-model="queryInfo.status"
            placeholder="请选择状态"
            clearable
          >
            <el-option value="1" label="有效"></el-option>
            <el-option value="0" label="无效"></el-option>
          </el-select>
        </el-col>

        <el-col :span="5">
          <el-select v-model="queryInfo.labelId" placeholder="请选择等级" clearable>
            <el-option
              v-for="item in options2"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" icon="el-icon-search" @click="getList"
          >查询
          </el-button>
        </el-col>
        <el-col :span="5">
          <el-button type="primary" @click="AddScenceList">新增</el-button>
        </el-col>

      </el-row>
      <!-- 小窝列表区域 -->
      <el-table :data="sceneList" style="width: 100%" border stripe>

        <el-table-column type="index"></el-table-column>

        <el-table-column prop="id" label="id" align="center"></el-table-column>

        <el-table-column
          prop="sceneName"
          label="小窝名称"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="sceneUrl"
          label="场景"
          align="center"
        >
          <template slot-scope="scope">
            <el-image :src="scope.row.sceneUrl"></el-image>
          </template>
        </el-table-column>

        <el-table-column
          prop="locked"
          label="付费类型"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.locked === 0 ? '免费' : scope.row.locked === 10 ? 'svip' : '会员' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="状态"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.status === 0 ? '无效' : '有效' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="charmValue"
          label="魅力值"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="labelUrl"
          label="标签"
          align="center"
        >
          <template slot-scope="scope" v-if="scope.row.labelUrl">
            <el-image :src="scope.row.labelUrl"></el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="type" label="会员状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.type == 0 ? '普通用户' : scope.row.type == 1 ? '永久会员' : scope.row.type == 2 ? '临时会员' : '普通用户' }}
          </template>
        </el-table-column> -->

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">

            <!-- 修改按钮 -->
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="updateByIdSel(scope.row)"
              style="marginRight:10px;"
            ></el-button>

              <el-button
                type="primary"
                icon="el-icon-delete"
                slot="reference"
                @click="deleteRow(scope.row.id)"
              ></el-button>



          </template>
        </el-table-column>

      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNum"
        :page-sizes="[10,30,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

    </el-card>





<!--修改-->
    <el-dialog
      title="修改"
      :visible.sync="updateDialogVisible"
      width="30%"
      @close="closeDialogVisible"
    >
      <!-- 内容主题区域  loading加载动画-->
      <el-form
        :model="updateForm"
        :rules="AddFormRules"
        ref="updateFormRef"
        label-width="100px"
        v-loading="loading"
        element-loading-text="正在修改中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >

        <el-form-item label="小窝名称" prop="sceneName"><!--小窝名称-->
          <el-input v-model="updateForm.sceneName" placeholder="请输入小窝名称"></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="updateForm.sort" placeholder="请输入排序值"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="updateForm.status">
            <el-option :value="0" label="无效"></el-option>
            <el-option :value="1" label="有效"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="封面">
          <el-upload
            ref="upload"
            class="upload-demo"
            style="margin-left: 24px;"
            action="''"
            accept=".jpg,.png,.jpeg"
            :limit="50"
            :on-change="handleUploadFileChange"
            :on-remove="removeFile"
            :file-list="updateFiles"
            :http-request="myUpload"
            multiple
          >
            <el-button size="small" type="primary">封面上传</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item label="魅力值" prop="charmValue">
          <el-input v-model="updateForm.charmValue" placeholder="请输入魅力值"></el-input>
        </el-form-item>
        <el-form-item label="标签：" prop="labelId">
          <el-select v-model="updateForm.labelId" placeholder="请选择等级" clearable>
            <el-option
              v-for="item in options2"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateInfo">确 定</el-button>
      </span>

    </el-dialog>

<!--添加-->
    <el-dialog
      title="新增"
      :visible.sync="AddDialogVisible"
      width="30%"
      @close="closeDialogVisible"
    >
      <!-- 内容主题区域  loading加载动画-->
      <el-form
        :model="AddDialogFormData"
        :rules="AddFormRules"
        ref="skinFormRef2"
        label-width="100px"
        v-loading="loading"
        element-loading-text="正在修改中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form-item label="小窝名称" prop="sceneName"><!--小窝名称-->
          <el-input v-model="AddDialogFormData.sceneName" placeholder="请输入小窝名称"></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="AddDialogFormData.sort" placeholder="请输入排序值"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="AddDialogFormData.status">
            <el-option :value="0" label="无效"></el-option>
            <el-option :value="1" label="有效"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="封面">
          <el-upload
            ref="upload"
            class="upload-demo"
            style="margin-left: 24px;"
            action="''"
            accept=".jpg,.png,.jpeg"
            :limit="50"
            :on-change="handleUploadFileChange"
            :on-remove="removeFile"
            :file-list="coverFiles"
            :http-request="myUpload"
            multiple
          >
            <el-button size="small" type="primary">封面上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="类型" prop="status">
          <el-select v-model="AddDialogFormData.locked">
            <el-option :value="10" label="svip"></el-option>
            <el-option :value="0" label="免费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签：" prop="labelId" v-if="AddDialogFormData.locked === 10">
          <el-select v-model="AddDialogFormData.labelId" placeholder="请选择标签" clearable>
            <el-option
              v-for="item in options2"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="魅力值" prop="charmValue">

          <el-input v-model="AddDialogFormData.charmValue" placeholder="请输入排序值"></el-input>
        </el-form-item>


      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddDialogInfo">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
// import {searchLike} from "../../../assets/util/likeSearch";
import moment from 'moment'

export default {
  data() {
    return {
      updateFiles: [],
      coverFiles: [],
      AddDialogVisible: false,    //新增弹窗的显示隐藏
      AddDialogFormData: {},//新增保存的数据

      AddFormRules: {      //新增弹窗必填选项
        locked: [
          {required: true, message: "请选择付费类型", trigger: "change"},
        ],
        sceneName: [
          {required: true, message: "请输入小窝名称", trigger: "blur"},
        ],
      },

      // 获取用户列表的参数对象
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        key: "",
      },
      channels: [],
      updateForm: {},
      //小窝装扮数据列表
      sceneList: [],
      updateDialogVisible: false,
      loading: false,
      total: null,
      filters: [],

      options2: [],
      sceneName: null, // 名称
      status: null, //状态
      sceneUrl: null, // 场景地址
      jumpUrl: null,// 跳转地址
      sort: null, // 排序
      volt: null, // 伏特值
      charmValue: null,//魅力值
      labelId: null, // 标签id
      locked: 10, // svip等级
      updateFormRules: {
        type: [
          {required: true, message: "请选择会员类型", trigger: "blur"},
        ],
        expirationTime: [
          {required: true, message: "请选择到期时间", trigger: "blur"},
        ],
      },
    };
  },
  //生命周期函数
  created() {
    this.getList();
    this.getLabel();
  },
  methods: {

    //新增小窝数据表
    AddScenceList() {
      this.$message.success('功能禁用中!')
      return ;
      this.AddDialogVisible = true;
      this.AddDialogFormData = {};
      this.coverFiles = [];
    },

    //确认新增
    AddDialogInfo() {

      console.log(this.coverFiles)
      this.loading = true;
      this.$refs.skinFormRef2.validate(async validate => {
        if (this.coverFiles) {
          let formData = new FormData();
          for (let key in this.AddDialogFormData) {
            // console.log(key+":"+this.AddDialogFormData[key])
            if (this.AddDialogFormData[key]) {
              formData.append(key, this.AddDialogFormData[key]);
            }
          }
          formData.append("locked",10);
          // formData.append('coverFiles', this.coverFiles)
          for (const h of this.coverFiles) {
            console.log(h.raw)
            formData.append('coverFiles', h.raw)
          }
          const {data: res} = await this.$http.post(
            "/chargeScene/save",
            formData
          );
          if (res.code === 200){
            this.AddDialogVisible = false;
            this.getList();
          }else {
            this.$message.error('新增失败！')
          }
          this.loading = false;
        }
      })



    },

    myUpload() {
      console.log(this.coverFiles);
    },

    //删除上传文件
    removeFile(file, fileList) {
      this.coverFiles = fileList
    },

    //上传小窝封面图
    handleUploadFileChange(file, fileList) {

      this.coverFiles = fileList
      // this.AddDialogVisible.
    },

    //删除一行列表
    deleteRow(id) {
      this.$message.success('功能禁用中！请修改状态达到不使用的目的~!');
      return;

      this.$confirm('确认删除小窝吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.$http.delete(`/chargeScene/delete?id=${id}`).then(() => {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList()
          })
        })
        .catch(() => {
        })
    },
    // 获取标签
    getLabel() {
      this.$http.get('/lable/getAll/web').then(res => {
        this.options2 = res.data.data
      });
    },


    // 监听pageSize 改变事件
    handleSizeChange(newSize) {
      console.log(newSize);
      this.queryInfo.pageSize = newSize;
      this.getList();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pageNum = newPage;
      this.getList();
    },

    // 获取小窝列表
    getList() {

      this.$http.get("/chargeScene/getPageList", {params: this.queryInfo}).then((res) => {
        this.sceneList = res.data.data.result;
        this.total = res.data.data.total;
        if (res.data.code != 200) return this.$message.error("获取小窝列表失败！");
      });
    },

    closeDialogVisible() {
      this.getList();
      //清空file缓存
    },

    // 打开修改窗口
    updateByIdSel(row) {
      // this.updateFiles = []
      this.updateDialogVisible = true
      // this.updateForm = row
      // console.log(row);
        const index = this.sceneList.findIndex(item => {
          return item.id === row.id
        })
        this.updateForm = this.sceneList[index]
    },

    // 确认修改
    updateInfo() {
      //开启加载动画
      this.loading = true;
      let formData = new FormData();
      for (let key in this.updateForm) {
        // console.log(key+":"+this.AddDialogFormData[key])
        if (key !== "updateTime" && key !== "createTime"){
          if (this.updateForm[key]) {
            formData.append(key, this.updateForm[key]);
          }
        }
      }
      this.$refs.updateFormRef.validate(async (valid) => {
        if (this.coverFiles) {
          for (const h of this.coverFiles) {
            formData.append('coverFiles', h.raw)
          }
        }
        this.$http.put(`/chargeScene/update`, formData).then((res) => {
          if (res.data.code !== 200) {
            this.loading = false;
            return this.$message.error("修改失败！" + " " + res.data.message);
          } else {
            this.sourceFiles = []
            this.$message.success("修改成功");
          }
          //刷新
          this.getList();
          // var a = 10;
          //关闭加载动画
          this.loading = false;
          //关闭对话框
          this.updateDialogVisible = false;
        })
      })
    },


  },
};
</script>

<style lang="less" scoped>
</style>
